<style>
    .input-block {
        position: relative;
    }
    .input-block {
        opacity: 1;
        left: 7px;
        padding: 0 3px;
    }
    .input-block label {
        position: absolute;
        font-weight: normal;
        top: 3px;
        left: 6px;
        opacity: 1;
        -webkit-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;
        pointer-events: none;
    }
    .input-block .label-active {
        opacity: 0.9;
        top: -12px;
        left: 7px;
        background: white;
        font-size: 13px;
        padding: 0 3px;
    }
</style>
<template>
    <div class="input-block">
        <input class="input-labeled" v-on:keyup.enter="onEnter" data-lpignore="true" type="text" v-model="innerValue" />
        <label :class="{'label-active': innerValue && innerValue.length > 0}">{{label}}</label>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                innerValue: ''
            };
        },
        methods: {
            onEnter(){
                this.$emit('enter-pressed');
            },
        },
        watch: {
            innerValue: function () {
              this.$emit('input', this.innerValue);
            },
            value: function () {
                this.innerValue = this.value;
            }
        },
        mounted() {
            this.innerValue = this.value;
        }
    };
</script>